import {
  FaBook,
  FaCheckDouble,
  FaCodeBranch,
  FaDocker,
  FaGithub,
  FaGitAlt,
  FaJava,
  FaLinkedin,
  FaLinux,
  FaPython,
  FaReact,
  FaTasks,
  FaXing,
} from "react-icons/fa";
import { DiDatabase, DiMysql, DiPostgresql } from "react-icons/di";
import {
  SiAnsible,
  SiAmazonaws,
  SiCypress,
  SiElixir,
  SiGit,
  SiGithubactions,
  SiGo,
  SiGrafana,
  SiHelm,
  SiJavascript,
  SiJest,
  SiKubernetes,
  SiMariadb,
  SiMicrosoftazure,
  SiPhoenixframework,
  SiPodman,
  SiPrometheus,
  SiRedux,
  SiSpringboot,
  SiStorybook,
  SiTerraform,
  SiTypescript,
} from "react-icons/si";

export const skillIconMap = {
  agile_scrum: FaTasks,
  ansible: SiAnsible,
  antora: FaBook,
  aws: SiAmazonaws,
  azure: SiMicrosoftazure,
  bash: FaBook,
  cicd: FaCodeBranch,
  commanded: FaTasks,
  cypress: SiCypress,
  docker: FaDocker,
  docs_as_code: FaBook,
  ecto: DiDatabase,
  elixir: SiElixir,
  git: SiGit,
  github_actions: SiGithubactions,
  gitlab: FaGitAlt,
  go: SiGo,
  grafana: SiGrafana,
  helm: SiHelm,
  java: FaJava,
  javascript: SiJavascript,
  jest: SiJest,
  kubernetes: SiKubernetes,
  linux: FaLinux,
  mariadb: SiMariadb,
  mysql: DiMysql,
  open_source: FaCodeBranch,
  phoenix: SiPhoenixframework,
  podman: SiPodman,
  postgresql: DiPostgresql,
  prometheus: SiPrometheus,
  python: FaPython,
  react: FaReact,
  redux: SiRedux,
  spring_boot: SiSpringboot,
  sqlite: DiDatabase,
  storybook: SiStorybook,
  tdd: FaCheckDouble,
  terraform: SiTerraform,
  typescript: SiTypescript,
};

export const socialIconMap = {
  github: FaGithub,
  linkedin: FaLinkedin,
  xing: FaXing,
};
